export enum CompareMode {
  PERCENTUAL = "percentual",
  ABSOLUTE = "absolute",
}

export enum UnitOfMeasurement {
  CBM = "m³",
  SSCC = "SSCC",
  SSCC_PLURAL = "SSCCs",
  WEIGHT = "kg",
}

type SummaryValue = {
  booked: number;
  received: number;
};
export type SummaryValues = {
  cbm: SummaryValue;
  weight: SummaryValue;
  quantity: SummaryValue;
};

export const defaultSummaryValues = {
  cbm: {
    booked: 0,
    received: 0,
  },
  weight: {
    booked: 0,
    received: 0,
  },
  quantity: {
    booked: 0,
    received: 0,
  },
};
